import React, { FC } from "react";
import { Input, InputProps } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { AveliosButton } from "../common-layout/avelios-button";
import styles from "./facility-search.module.scss";

interface FacilitySearchProps extends InputProps {}

export const FacilitySearch: FC<FacilitySearchProps> = ({ ...props }) => {
  return (
    <Input.Group compact>
      <Input {...props} className={styles.search} />
      <div
        style={{
          width: 45,
          backgroundColor: "#FFE388",
          borderRadius: "0 10px 10px 0",
          border: "0.5px solid black",
        }}
      >
        <AveliosButton
          style={{
            backgroundColor: "#FFE388",
            borderRadius: "0 10px 10px 0",
          }}
          size={"large"}
          icon={<SearchOutlined />}
        />
      </div>
    </Input.Group>
  );
};
